import { DocumentType } from '@prisma/client';
import z from 'zod';

export const documentSchema = z.object({
  original_filename: z.string().optional(),
  document_type: z
    .nativeEnum(DocumentType, {
      invalid_type_error: 'Invalid Document Type',
    })
    .optional(),
  request_id: z.number().nullish(),
});
